import { CTASection } from "../../models/page-builder/CTA-section.model";

// Define mock data

export const MOCK_CTA_SECTION: CTASection = {
  type: "CTA",
  content: {
    headings: {
      title: "Join 4,000+ users growing with OnlineCourseHost",
      titleColor: "#000",
      subTitle:
        "Start your free trial today and take your place in our growing community every day",
      subTitleColor: "#666",
    },
    media: {
      mediaFileUrl: {
        type: "image",
        originalFileName: "background-original.jpg",
        uploadFileName: "background.jpg",
        url: "https://picsum.photos/1406/400",
        imageSettings: {
          overlayWithBackground: true,
          opacity: 0.1,
          blending: "normal",
          blur: 2,
          grayScale: 10,
          contrast: 100,
        },
      },
    },
    benefits: {
      show: true,
      iconAlignment: true,
      items: [
        "30-day free trial",
        "Peronalized onboarding",
        "Access to all features",
      ],
      icon: {
        enabled: true,
        svgName: "optionIcon-7",
        color: "#fff",
      },
    },
    buttons: {
      items: [
        {
          buttonText: "Explore",
          buttonLink: "https://itsmekamal.com",
          textColor: "#333",
          backgroundColor: "#009688",
          borderColor: "#0096",
        },
        {
          buttonText: "Get Started",
          buttonLink: "https://onlinecoursehost.com",
          textColor: "#000",
          backgroundColor: "#ff5722",
          borderColor: "#000",
        },
      ],
      buttonHint: "Click here to get started!",
      buttonHintColor: "#000",
    },
  },
  design: {
    layout: "card",
    textAlignment: "left",
    mediaAlignment: "leftRight",
    appearance: {
      backgroundColor: "#fafafa",
      benefitIconBgColor: "#ccc",
      cardBgColor: "#e0e0e0",
      backgroundImageUrl: {
        type: "image",
        originalFileName: "background-original.jpg",
        uploadFileName: "background.jpg",
        url: "https://picsum.photos/2000/2000",
        imageSettings: {
          overlayWithBackground: true,
          opacity: 0.1,
          blending: "normal",
          blur: 2,
          grayScale: 10,
          contrast: 100,
        },
      },
    },
  },
};
